import { useEffect, useState } from 'react';

// Breakpoint unic pentru layout mobil/desktop (aliniat cu lg din Bootstrap).
export const MOBILE_BREAKPOINT = 992;

export default function useIsMobile() {
    const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile;
}
